export var EndpointIDs;
(function (EndpointIDs) {
    /**
     * The create function takes an API client and returns a dictionary of endpoint identifiers to be used for declaring refetch queries and for testing.
     * @param apiClient The API client to parse, must be an object containing controller objects with nested endpoint functions
     * @returns A dictionary of endpoint identifiers to be used for declaring refetch queries and for testing.
     */
    function create(apiClient) {
        // Reduce client controller dictionary into endpoint ID functions
        return Object.keys(apiClient).reduce((memo, controllerKey) => {
            const newMemo = Object.assign({}, memo);
            const controller = apiClient[controllerKey];
            newMemo[controllerKey] = Object.keys(controller).reduce((incomingControllerDictionary, endpointKey) => {
                // A string unique to the endpoint - combines the controller and endpoint names
                const endpointHash = `${controllerKey}.${endpointKey}`;
                const controllerDictionary = Object.assign({}, incomingControllerDictionary);
                controllerDictionary[endpointKey] = (config) => {
                    return Object.assign({ endpointHash }, (config !== null && config !== void 0 ? config : {}));
                };
                return controllerDictionary;
            }, {});
            return newMemo;
        }, {});
    }
    EndpointIDs.create = create;
    /**
     * The create function takes a dictionary of API clients and returns a dictionary of endpoint identifiers to be used for declaring refetch queries and for testing.
     * @param apiClientDictionary A dictionary of API clients to parse, must be an object containing client key strings mapped to clients containing controller objects with nested endpoint functions
     * @returns A dictionary of endpoint identifiers to be used for declaring refetch queries and for testing.
     */
    function createMulti(apiClientDictionary) {
        return Object.keys(apiClientDictionary).reduce((memo, clientKey) => {
            const newMemo = Object.assign({}, memo);
            const client = apiClientDictionary[clientKey];
            newMemo[clientKey] = create(client);
            return newMemo;
        }, {});
    }
    EndpointIDs.createMulti = createMulti;
})(EndpointIDs || (EndpointIDs = {}));
